import { utils, writeFileXLSX } from 'xlsx'
import {
  cas,
  unit,
  lead_time,
  formatted_lead_time,
  purity,
  quantity,
  shipping_temp,
  check_is_cold,
  supplier,
  manufacturer,
  price,
  price_unit,
  xlsx_formula,
} from '../services/xlsx_formatted_data'
export default class ExportToXlsx {
  dataForExcel: Object[] = []

  constructor(data: []) {
    data.forEach((product: productInterface) => {
      this.dataForExcel.push({
        'Supplier': supplier(product),
        'SKU': product.sku.toLocaleUpperCase(),
        'Item': product.item,
        'Purity': purity(product.purity),
        'Lead-time': lead_time(product.leadtime),
        'Срок поставки': formatted_lead_time(product),
        'CAS': cas(product.cas),
        'Manufacturer': manufacturer(product),
        'Quantity': quantity(product.quantity.toLocaleLowerCase()),
        'Unit': unit(product.unit),
        'Shipping temp (storage)': shipping_temp(product.shipping_temp),
        'Тип - Холодовая химия': check_is_cold(product.shipping_temp),
        'Price amount': price(product),
        'Price units': price_unit(product),
        'Danger': product.danger ? 'ДА' : 'Non chemical',
        'Formula': xlsx_formula(product),
      })
    })
  }

  exportToFile() {
    const ws = utils.json_to_sheet(this.dataForExcel)
    ws['!cols'] = [
      { wch: 8 },
      { wch: 15 },
      { wch: 20 },
      { wch: 10 },
      { wch: 15 },
      { wch: 30 },
      { wch: 10 },
      { wch: 10 },
      { wch: 8 },
      { wch: 8 },
      { wch: 15 },
      { wch: 10 },
      { wch: 10 },
      { wch: 10 },
      { wch: 15 },
      { wch: 100 },
    ]
    const wb = utils.book_new()
    utils.book_append_sheet(wb, ws, 'Лист 1')
    writeFileXLSX(wb, 'products.xlsx')
  }
}
